import { Dto, DtoWithId } from '@mango/core';

@Dto({fullName: "AccessMonitor.Logic.User", archivable: true})
export class User extends DtoWithId {
    email: string;
    firstName: string;
    lastName: string;
    name: string;
    mfaEnabled: boolean;
    archivedOn: boolean;
    locked: boolean;
    lastPasswordChanged: Date;
    lastLogin: Date;
    isMfaExempt: boolean;
}